(() => {
  'use strict';
  if (window.__phUXDispatchV38Loaded) return;
  window.__phUXDispatchV38Loaded = true;

  const AMSTERDAM_TZ = 'Europe/Amsterdam';
  const CUTOFF_HOUR = 16;

  const localeMap = {
    nl: 'nl-NL',
    de: 'de-DE',
    fr: 'fr-FR',
    pl: 'pl-PL',
    en: 'en-GB'
  };
  const shippingLabels = {
    nl: 'Verzending:',
    de: 'Versand:',
    fr: 'Expédition :',
    pl: 'Wysyłka:',
    en: 'Dispatch:'
  };
  const todayLabels = {
    nl: 'Vandaag verzonden',
    de: 'Versand heute',
    fr: "Expédition aujourd’hui",
    pl: 'Wysyłka dzisiaj',
    en: 'Dispatched today'
  };

  function languageCode() {
    const raw = (document.documentElement.lang || 'nl').toLowerCase();
    const code = raw.slice(0, 2);
    return localeMap[code] ? code : 'nl';
  }

  let amsterdamFormatter;
  function amsterdamNowParts() {
    if (!amsterdamFormatter) amsterdamFormatter = new Intl.DateTimeFormat('en-GB', {
      timeZone: AMSTERDAM_TZ,
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      hourCycle: 'h23'
    });
    const parts = amsterdamFormatter.formatToParts(new Date());
    const values = {};
    parts.forEach((p) => {
      if (p.type !== 'literal') values[p.type] = Number(p.value);
    });
    return values;
  }

  function dateOnlyUTC(year, month, day) {
    return new Date(Date.UTC(year, month - 1, day));
  }

  // Daily cutoff: the next calendar day, including Saturdays and Sundays.
  function nextCalendarDay(date) {
    const result = new Date(date.getTime());
    result.setUTCDate(result.getUTCDate() + 1);
    return result;
  }

  function formatDeliveryDate(date, locale, compact = false) {
    return new Intl.DateTimeFormat(locale, {
      weekday: compact ? 'short' : 'long',
      day: 'numeric',
      month: compact ? 'short' : 'long',
      timeZone: 'UTC'
    }).format(date);
  }

  function renderDeliveryEstimates() {
    const elements=document.querySelectorAll('[data-ph-delivery-estimate]');if(!elements.length)return;
    const code=languageCode(),locale=localeMap[code],now=amsterdamNowParts();
    const dispatch=dateOnlyUTC(now.year,now.month,now.day);if(now.hour>=CUTOFF_HOUR)dispatch.setUTCDate(dispatch.getUTCDate()+1);
    const first=nextCalendarDay(dispatch),last=nextCalendarDay(first);
    const range=new Intl.DateTimeFormat(locale,{day:'numeric',month:'short',timeZone:'UTC',...(first.getUTCFullYear()!==last.getUTCFullYear()?{year:'numeric'}:{})}).formatRange(first,last);
    elements.forEach(element=>{
      const target=element.querySelector('[data-ph-shipping-date]');if(!target)return;
      const available=element.dataset.phAvailable!=='0';
      const message=available?(element.dataset.phArrivalTemplate||'Estimated delivery: __DATE__').replace('__DATE__',range):'';
      if(target.textContent!==message)target.textContent=message;
      element.dataset.phDispatchDate=dispatch.toISOString().slice(0,10);
      element.dataset.phArrivalFrom=first.toISOString().slice(0,10);element.dataset.phArrivalTo=last.toISOString().slice(0,10);
    });
  }

  function initDispatchUpdates() {
    let frame = 0;
    const refresh = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        renderDeliveryEstimates();
      });
    };
    ['themeVariantUpdated', 'themeCartUpdated', 'themeCartOpened', 'shopify:section:load', 'phCartRecommendationsLoaded'].forEach((name) => {
      document.addEventListener(name, refresh);
      window.addEventListener(name, refresh);
    });
    // Catch cards inserted by filtering, search, recommendations and infinite scrolling.
    if (window.MutationObserver && document.body) {
      new MutationObserver((records) => {
        const hasNewEstimate = records.some((record) => Array.from(record.addedNodes).some((node) =>
          node.nodeType === 1 && (node.matches('[data-ph-delivery-estimate]') || node.querySelector('[data-ph-delivery-estimate]'))
        ));
        if (hasNewEstimate) refresh();
      }).observe(document.body, { childList: true, subtree: true });
    }
    // Recalculate at each minute boundary, including 16:00, without a page reload.
    const tick = () => {
      if (!document.hidden) refresh();
      window.setTimeout(tick, 60000 - (Date.now() % 60000) + 25);
    };
    window.setTimeout(tick, 60000 - (Date.now() % 60000) + 25);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) refresh(); });
    window.addEventListener('pageshow', refresh);
    window.addEventListener('focus', refresh);
  }

  function formatCurrencyCents(cents, currency) {
    const code = languageCode();
    const locale = localeMap[code] || 'nl-NL';
    const value = Math.max(0, Number(cents) || 0) / 100;
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency || 'EUR'
      }).format(value);
    } catch (error) {
      return `€${value.toFixed(2).replace('.', ',')}`;
    }
  }

  function smartUpsellScore(price, gap) {
    if (!Number.isFinite(price) || price <= 0) return Number.MAX_SAFE_INTEGER;
    const distance = Math.abs(price - gap);
    const undershootPenalty = price < gap ? Math.max(600, gap * 0.8) : 0;
    const overshootPenalty = price > gap * 2.5 && gap > 0 ? (price - gap * 2.5) * 0.35 : 0;
    return distance + undershootPenalty + overshootPenalty;
  }

  function applySmartCartUpsell(element) {
    if (!element || !element.classList || !element.classList.contains('cart-upsell')) return;
    const list = element.querySelector('.l4ca');
    const heading = element.querySelector('h3');
    if (!list) return;

    const cards = Array.from(list.children).filter((card) => card.matches('li[data-product-id]'));
    if (!cards.length) return;

    const gap = Math.max(0, parseInt(element.dataset.phGap || '0', 10) || 0);
    const currency = element.dataset.phCurrency || 'EUR';
    let ordered = cards.slice();

    cards.forEach((card) => card.classList.remove('ph-smart-hidden'));

    if (gap > 0) {
      ordered.sort((a, b) => {
        const priceA = parseInt(a.dataset.phPrice || '0', 10) || 0;
        const priceB = parseInt(b.dataset.phPrice || '0', 10) || 0;
        return smartUpsellScore(priceA, gap) - smartUpsellScore(priceB, gap);
      });
      element.classList.add('ph-smart-gap');
      if (heading && element.dataset.phGapHeading) {
        heading.textContent = element.dataset.phGapHeading.replace('__PH_AMOUNT__', formatCurrencyCents(gap, currency));
      }
    } else {
      element.classList.remove('ph-smart-gap');
    }

    const selected = new Set(ordered.slice(0, 3));
    ordered.slice(0, 3).forEach((card) => list.appendChild(card));
    cards.forEach((card) => {
      if (!selected.has(card)) card.classList.add('ph-smart-hidden');
    });
  }

  function initSmartCartUpsell() {
    document.querySelectorAll('.cart-upsell').forEach(applySmartCartUpsell);
  }

  window.addEventListener('phCartRecommendationsLoaded', (event) => {
    applySmartCartUpsell(event.detail && event.detail.element ? event.detail.element : null);
  });
  window.addEventListener('themeCartOpened', () => {
    window.setTimeout(initSmartCartUpsell, 0);
  });

  function init() {
    renderDeliveryEstimates();
    initDispatchUpdates();
    initSmartCartUpsell();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

})();
